/* ==========================================================================
   Rising Health — the signature reveal.

   One IntersectionObserver for the whole page. It adds `is-in` to any element
   carrying `data-rh-reveal` when it enters the viewport, and never removes it
   — content does not un-reveal when you scroll back up, because that reads as
   a glitch rather than an effect.

   Everything visual lives in CSS (`[data-rh-wipe]` in z-rising-tokens.css).
   This file only decides *when*. That split matters: it means the motion is a
   masked clip-path handled by the compositor, and this script never touches a
   style property.

   Deliberately not a library. The theme already ships ~830 KB of JavaScript;
   adding GSAP or Motion to fade some rules in would be indefensible. This is
   under 1 KB and does the same job.
   ========================================================================== */
(function () {
  "use strict";

  var SEL = "[data-rh-reveal]";

  function showAll() {
    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add("is-in");
  }

  /* Three ways to opt out, and all of them mean "just show me the content":
     the visitor asked for reduced motion, the merchant switched Pebble's
     animations off in theme settings, or the browser is too old for
     IntersectionObserver. */
  function disabled() {
    return (
      window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
      document.body.hasAttribute("data-motion-disabled") ||
      typeof IntersectionObserver === "undefined"
    );
  }

  function init() {
    if (disabled()) {
      showAll();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var e = entries[i];
          if (!e.isIntersecting) continue;
          e.target.classList.add("is-in");
          io.unobserve(e.target);
        }
      },
      {
        /* Fire a little before the section is fully on screen so the wipe has
           finished by the time the reader's eye arrives, and so anything that
           is already in view on load reveals immediately rather than sitting
           blank until the first scroll. */
        rootMargin: "0px 0px -12% 0px",
        threshold: 0.01,
      }
    );

    var nodes = document.querySelectorAll(SEL);
    for (var i = 0; i < nodes.length; i++) io.observe(nodes[i]);

    /* Sections added by the theme editor after load (adding or reordering a
       section re-renders it) need observing too. */
    document.addEventListener("shopify:section:load", function (evt) {
      var t = evt.target;
      if (!t) return;
      if (t.matches && t.matches(SEL)) io.observe(t);
      var inner = t.querySelectorAll ? t.querySelectorAll(SEL) : [];
      for (var j = 0; j < inner.length; j++) io.observe(inner[j]);
    });

    /* In the theme editor the merchant is scrubbing settings, not reading the
       page. Reveal everything so nothing appears broken while they work. */
    if (window.Shopify && window.Shopify.designMode) showAll();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
